import { render, staticRenderFns } from "./switch-modal.vue?vue&type=template&id=1890ffde"
import script from "./switch-modal.ts?vue&type=script&lang=ts&external"
export * from "./switch-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports